import React from 'react';
import { Elements } from '@stripe/react-stripe-js';
import config from '$/config';

// Stripe script will always be load if it imported in the code.
let stripePromise: Promise<any> | null = null;

interface StripeLoaderProps {
  uniqueId?: string;
  children?: React.ReactNode;
}

export const StripeLoader: React.FC<StripeLoaderProps> = ({ children }) => {
  const [scriptLoaded, setScriptLoaded] = React.useState<boolean>(stripePromise !== null);
  React.useEffect(() => {
    if (!scriptLoaded) {
      const Stripe = require('@stripe/stripe-js');
      stripePromise = Stripe.loadStripe(config.STRIPE_PK);
      setScriptLoaded(true);
    }
  }, [scriptLoaded]);
  return <Elements stripe={stripePromise}>{children}</Elements>;
};

export const withStripeLoader = <T extends object>(
  Component: React.FC<T>
): React.MemoExoticComponent<React.FC<T>> => {
  const WithStripeLoaderComponent: React.FC<T> = (props) => {
    return (
      <StripeLoader>
        <Component {...props} />
      </StripeLoader>
    );
  };
  return React.memo<React.FC<T>>(WithStripeLoaderComponent);
};
